import React from "react"
import Container from "react-bootstrap/Container";

const Educations = props => (
    <div className="container my-5">
        {props.children}
    </div>

)

function Formation({title, location, from, to, university}) {
    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title" style={{color: "white"}}>{title}</h5>
                <h6 className="card-subtitle mb-2 text-muted">{university}</h6>
                <p className="card-text">{from} - {to}</p>

            </div>
        </div>
    )
}

export default function Education() {
    return (
        <Container as={"section"} id="education">
            <h3 className={"section-title"} style={{textAlign: `right`}}>Education</h3>

            <div className="separator pt-3">
                <Educations>
                    <Formation title={"Ph.D. candidate in Mathematics and Computer Science"} location={"Barcelona"}
                               from={"2015"} to={'    '} university={"Universitat de Barcelona"}/>
                    <Formation title={"M.Sc. in Artificial Intelligence"} location={"Barcelona"} from={"2012"}
                               to={'2014'} university={"Universitat Politècnica de Catalunya"}/>
                    <Formation title={"B.Sc. in Computer Engineering"} location={"Barcelona"} from={"2008"}
                               to={'2012'} university={"Universitat de Barcelona"}/>
                    <Formation title={"B.A. in Philosophy"} location={"Barcelona"} from={"2003"}
                               to={'2006'} university={"Universitat de Barcelona"}/>
                </Educations>
            </div>
        </Container>
    )
}